$(() => {
  const $openingHoursToggleButton = $(
    ".partner-site-header-details-opening-hours__toggle",
  );

  $($openingHoursToggleButton).on("click", function () {
    $(this).next().toggleClass("showOpeningHours");
  });

  $(document).on("click", function (e) {
    const $target = $(e.target);
    const $openingHoursOuterWrapper = $(
      ".partner-site-header-details-opening-hours",
    );
    const $openingHoursInnerContentContainer = $(".opening-hours-container");

    if (
      !$target.closest($openingHoursOuterWrapper).length &&
      $openingHoursInnerContentContainer.hasClass("showOpeningHours")
    ) {
      $openingHoursInnerContentContainer.removeClass("showOpeningHours");
    }

    if (!$target.closest(".info-box").length || $target.is(".info-box")) {
      $(".info-box.popup-box").removeClass("info-box-active");
    }
  });

  const $operatingHoursToggleButton = $(".operating-hours-popup>a");

  $operatingHoursToggleButton.on("click", function () {
    $(this).parents(".info-box").toggleClass("info-box-active");
  });
});
